import Input from '@material-ui/core/Input'
import FontStyleInput from 'lib/ui/typography/FontStyleInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import {AgendaSectionProps} from 'Event/template/Townhall/Dashboard/Main/AgendaSection'
import {onChangeCheckedHandler} from 'lib/dom'
import Switch, {EnabledSwitch} from 'lib/ui/form/Switch'
import TextField from 'lib/ui/TextField'
import {Label} from 'lib/ui/typography'
import React from 'react'
import {Controller} from 'react-hook-form'
import {useConfig} from 'organization/Event/Configurable'
import {useTownhallTemplate} from 'Event/template/Townhall'
import InputLabel from 'lib/ui/TextField/InputLabel'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  agendaSection: AgendaSectionProps
  sectionId: string
}) {
  const {agendaSection, sectionId} = props
  const {
    form: {control, register},
  } = useConfig()
  const {
    navBar: {menuItems},
  } = useTownhallTemplate()

  const v = useAttendeeVariables()
  return (
    <>
      <Controller
        name={`dashboardSections.${sectionId}.isEnabled`}
        control={control}
        defaultValue={agendaSection.isEnabled}
        render={({value, onChange}) => (
          <EnabledSwitch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
            arial-label="config enabled switch"
          />
        )}
      />
      <Controller
        name={`navBar.menuItems.${sectionId}.isEnabled`}
        defaultValue={menuItems[sectionId]?.isEnabled ?? true}
        control={control}
        render={({value, onChange}) => (
          <Switch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
            labelPlacement="end"
            label={value ? 'Show NavBar Item' : 'Hide NavBar Item'}
            aria-label="toggle hide navbar item"
          />
        )}
      />
      <InputLabel>Menu Title</InputLabel>
      <TextField
        name={`navBar.menuItems.${sectionId}.title`}
        defaultValue={v(menuItems[sectionId]?.title ?? agendaSection.title)}
        aria-label="update blogs menu title"
        fullWidth
        inputProps={{
          ref: register,
        }}
      />
      <InputLabel>Title</InputLabel>
      <TextField
        name={`dashboardSections.${sectionId}.title`}
        defaultValue={v(agendaSection.title)}
        aria-label="update agendas title"
        fullWidth
        inputProps={{
          ref: register,
        }}
      />
      <Label>Description</Label>
      <Controller
        name={`dashboardSections.${sectionId}.description`}
        control={control}
        defaultValue={v(agendaSection.description || '')}
        render={({value, onChange}) => (
          <Input
            id="agenda-adornment-description"
            type="text"
            value={value}
            onChange={onChange}
            aria-label="update agendas description"
            fullWidth
            endAdornment={
              <InputAdornment position="end">
                <Controller
                  name={`dashboardSections.${sectionId}.descriptionFontStyles`}
                  control={control}
                  defaultValue={agendaSection.descriptionFontStyles || ''}
                  render={({value, onChange}) => (
                    <FontStyleInput onChange={onChange} value={value} />
                  )}
                />
              </InputAdornment>
            }
          />
        )}
      />
      <Label mt={6}>Footer</Label>
      <Controller
        name={`dashboardSections.${sectionId}.footer`}
        control={control}
        defaultValue={v(agendaSection.footer || '')}
        render={({value, onChange}) => (
          <Input
            id="agenda-adornment-footer"
            type="text"
            value={value}
            onChange={onChange}
            aria-label="update agendas footer"
            fullWidth
            endAdornment={
              <InputAdornment position="end">
                <Controller
                  name={`dashboardSections.${sectionId}.footerFontStyles`}
                  control={control}
                  defaultValue={agendaSection.footerFontStyles || ''}
                  render={({value, onChange}) => (
                    <FontStyleInput onChange={onChange} value={value} />
                  )}
                />
              </InputAdornment>
            }
          />
        )}
      />
    </>
  )
}
